/** 
*@author: Sirisha.M
*@Description : 
**/
/* eslint-disable no-unused-vars */

import _ from 'lodash';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { constant } from '../Utils/constants';
import translation from '../Utils/translation';
import { IPAddress, UPLOAD } from '../../../commons/api';

import axios from 'axios';
import Highlighter from 'react-highlight-words';
import InputComponent from '../Utils/InputComponent';
import localStorage from '../../../utils/localStorage';
import SelectComponent from '../Utils/SelectComponent';
import { connect } from 'react-redux';
import StyledTable from '../../../commons/styles/table';
import SelectWithAddComponent from '../Utils/SelectWithAddComponent';
import themeSettings from '../../../commons/styles/themeSettings.json';
import { DownloadOutlined, UploadOutlined, SearchOutlined } from '@ant-design/icons';
import { Form, Input, message, Space, Tabs, Select, Divider, Upload, Button } from 'antd';
import {
  getAssetDetailsById,
  getAssetAttributeList,
  saveAsset,
  saveAssetParameter,
  getAssetParameterFileDownloadNameAPI,
  getPriorityList,
  getAssetParametersList
} from '../APICalls';

const { TabPane } = Tabs;
const { Option } = Select;

const Asset = (props) => {
  const [formObject, setFormObject] = useState({});
  const [attributeList, setAttributeList] = useState([]);
  const [formType, setFormType] = useState('');
  const [parametersList, setParametersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [AssetType, setAssetType] = useState('');
  const [LevelCode, setLevelCode] = useState('');
  const [AssetTypeCode, setAssetTypeCode] = useState('');
  const [AssetTypeList, setAssetTypeList] = useState([]);
  const [priorityList, setPriorityList] = useState([]);
  const [parameterFileName, setParameterFileName] = useState('');
  const [searchText, setSearchText] = useState('');
  const [DuplicateList, setDuplicateList] = useState([]);
  const [SelectedRow, setSelectedRow] = useState('');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  let searchInput = useRef(null);
  const hRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      await setData(props.ShowForm);
      await GetDeviceType();
    };
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    fetchData();
  }, [props.ShowForm, props.selectedRow]);

  const getassetTypeList = async (key, Code, type) => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `/api/rubusMaster/hierarchy/getAssetTypesByParent?SiteId=${siteId}&key=${key}&ModuleCode=${Code}&LevelType=${type}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    try {
      const response = await axios(headers);
      return response.data;
    } catch (error) {
      // Handle error if needed
      return null;
    }
  };

  const setData = async (ShowForm) => {

    let { Module } = props;
    let findADDMatch = JSON.stringify(ShowForm).match(`Asset`) !== null;
    let findEDITMatch = JSON.stringify(ShowForm).match(`EDIT`) !== null;
    let assetTypeList = await getassetTypeList(props.ModuleKey, props.Module, 'Asset');
    setAssetTypeList(assetTypeList);
    if (findADDMatch === true) {
      onReset();
      let attributeList = await getAssetAttributeList(props.formTypeName, Module);
      setAttributeList(attributeList);
      setFormType('Asset');
    } else if (findEDITMatch === true) {
      let { selectedRow, formTypeName } = props;
      if (selectedRow.Code) {
        let formObject = await getAssetDetailsById(selectedRow.Code);

        let attributeList = await getAssetAttributeList(formTypeName, Module);

        getParameterList(
          formObject && formObject[0] && formObject[0].AliasCode,
          formObject && formObject[0] && formObject[0].AssetTypeCode
        );
        getParameterFileDownloadName(
          selectedRow.Code,
          formObject && formObject[0] && formObject[0].AssetTypeCode
        );
        let updatedObject = {
          ...formObject[0],
          UniqueCode: formObject && formObject[0] && formObject[0].AssetCode
        };

        hRef.current && hRef.current.setFieldsValue({ ...updatedObject });
        setFormObject(updatedObject || {});
        setAssetTypeCode(formObject && formObject[0] && formObject[0].AssetTypeCode);
        setFormType('EDIT');
        setAttributeList(attributeList);
      } else {
        message.error('Code missing in hierarchy structure');
      }
    }
  };
  const onReset = () => {
    hRef.current && hRef.current.resetFields();
    hRef.current &&
      hRef.current.setFieldsValue({
        Name: null,
        Description: null,
        DisplayCode: null,
        UniqueCode: null,
        Id: null,
        Manufacturer: null,
        Section: null,
        AssetTypeCode: null,
        SerialNo: null,
        SerialNo1: null,
        SerialNo2: null
      });
    setFormObject({});
    setAssetType('');
  };

  const onAssetCRUD = async () => {
    let { selectedRow } = props;

    const siteId = localStorage.get('currentSite');
    hRef.current
      .validateFields()
      .then(async (values) => {
        values = {
          ...hRef.current.getFieldsValue()
        };
        let payload = {};
        if (values.Id) {
          payload = {
            ...values,
            ModuleCode: props.Module,
            ParentAsset:
              props.parent && props.parent.Type === 'Module' ? null : props.parent.Code,
            LevelCode: formObject.LevelCode
          };
        } else {
          delete values.Id;
          payload = {
            ...values,
            ModuleCode: props.Module,
            AssetType: AssetType || '',
            ParentAsset: selectedRow && selectedRow.Type === 'Module' ? null : selectedRow.Code,
            // AssetGroup: '',
            SiteId: siteId,
            LevelCode: LevelCode
          };
        }
        let saveResponse = await saveAsset(payload);
        if (saveResponse && saveResponse.message) {
          message.success(saveResponse.message);
          props.GetHierarchyLevelsUpdated();
          onReset();
        }
      })
      .catch((e) => {
        console.error("Error", e);
      });
  };

  const onFieldChange = async (fieldValue, fieldName) => {
    setFormObject((prevFormObject) => ({
      ...prevFormObject,
      [fieldName]: fieldValue
    }));
    hRef.current &&
      hRef.current.setFieldsValue({
        [fieldName]: fieldValue
      });
  };

  const renderWidget = (propsData) => {
    let { widget, Code, isEditableOnUpdate, API } = propsData;

    switch (widget) {
      case 'selectWithAdd':
        return (
          <SelectWithAddComponent
            value={formObject && formObject[Code] ? formObject[Code] : ''}
            Code={propsData && propsData.Code ? propsData.Code : ''}
            formObject={formObject}
            api={API}
            ModuleCode={props.Module}
            onSelectChange={(e) => onFieldChange(e, Code)}
          />
        );
      case 'select':
        return (
          <SelectComponent
            value={formObject && formObject[Code] ? formObject[Code] : ''}
            Code={propsData && propsData.Code ? propsData.Code : ''}
            formObject={formObject}
            api={API}
            ModuleCode={props.Module}
            onSelectChange={(e) => onFieldChange(e, Code)}
          />
        );
      default:
        return (
          <InputComponent
            value={
              formObject && formObject[Code]
                ? translation(translationCache, formObject[Code])
                : ''
            }
            disabled={formObject.Id && isEditableOnUpdate === 'false' ? true : false}
            onChange={(e) => onFieldChange(e, Code)}
          />
        );
    }
  };

  const formSentence = (formTypeName, selectedRow, formType) => {
    if (formTypeName && formTypeName === 'CAR') {
      if (formType === 'Asset') {
        return `${_.startCase(formTypeName.toLowerCase())} creation for ${selectedRow.Name ? selectedRow.Name : ''
          }`;
      } else {
        return `Edit ${formTypeName.toLowerCase()} details for ${selectedRow.Name ? selectedRow.Name : ''
          }`;
      }
    } else {
      if (formType === 'Asset') {
        return `Creation of Asset`;
      } else {
        return `Edit details for ${selectedRow.Name ? selectedRow.Name : ''}`;
      }
    }
  };

  const getParameterFileDownloadName = async (AssetAlias, AssetTypeCode) => {
    let parameterFileName = await getAssetParameterFileDownloadNameAPI(AssetAlias, AssetTypeCode);
    setParameterFileName(parameterFileName && parameterFileName.file ? parameterFileName.file : '');
  };

  const GetDeviceType = async () => {
    let priorityList = await getPriorityList();
    setPriorityList(priorityList);
  };

  const getParameterList = async (DeviceAlias, AssetTypeCode) => {
    let parametersList = await getAssetParametersList(DeviceAlias, AssetTypeCode);
    let DuplicateList = await getAssetParametersList(DeviceAlias, AssetTypeCode);

    parametersList &&
      Array.isArray(parametersList) &&
      parametersList.map((record) => {
        record['Editable'] = 'false';
        return {};
      });
    DuplicateList &&
      Array.isArray(DuplicateList) &&
      DuplicateList.map((record) => {
        record['Editable'] = 'false';
        return {};
      });
    setParametersList(parametersList);
    setDuplicateList(DuplicateList);
  };

  const saveRow = async (record) => {
    let { selectedRow } = props;
    setLoading(true);
    let payload = {
      ...record,
      AssetAlias: selectedRow && selectedRow.Code
    };

    let t1 = await saveAssetParameter(payload, selectedRow && selectedRow.Code);
    message.success(t1 && t1.message);
    let uot = getParameterList(selectedRow && selectedRow.Code, AssetTypeCode);
    getParameterFileDownloadName(selectedRow && selectedRow.Code, AssetTypeCode);

    if (uot) {
      record['Editable'] = 'false';
      setLoading(false);
      setParametersList(uot);
    }
  };

  const handleFieldChange = (value, fieldName, recordKey) => {
    // const DuplicateList = parametersList;
    const updatedList = parametersList.map((item) => {
      if (item.Code === recordKey) {
        return { ...item, [fieldName]: value };
      }
      return item;
    });
    setParametersList(updatedList);
    // setDuplicateList(DuplicateList);
  };
  const cancel = () => {
    // Revert changes by resetting to the original list
    setParametersList(DuplicateList); // Reset editable list to original values
  };


  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, constant.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}

          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, constant.search)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}

          style={{ width: 90 }}
        >
          {translation(props.translationCache, constant.Reset)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: () => {
      setTimeout(() => searchInput.current.select());
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const editRow = (key) => {
    const DuplicateList = parametersList;
    const updatedList = parametersList.map((item) => {
      if (item.Code === key) {
        return { ...item, Editable: 'true' };
      }
      return item;
    });
    setParametersList(updatedList);
    setDuplicateList(DuplicateList);
    setSelectedRow(key);
  };

  const handleKeyPress = (e, recordKey) => {
    if (e.key === 'Enter') {
      const record = parametersList.find((item) => item.Code === recordKey);
      if (record) saveRow(record);
    }
  };
  const onChange = (value) => {
    let matchedObject =
      AssetTypeList &&
      Array.isArray(AssetTypeList) &&
      AssetTypeList.find((asset) => asset.Code === value);
    setAssetType(matchedObject.Type);
    setLevelCode(matchedObject.LevelCode);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'Name',
      ...getColumnSearchProps('Name')
    },
    {
      title: 'Description',
      dataIndex: 'ParameterDescription',
      key: 'ParameterDescription',
      ...getColumnSearchProps('ParameterDescription'),
      render: (text, record) => {

        if (record.Editable === 'true') {

          return (
            <Input
              value={text}
              onChange={(e) =>
                handleFieldChange(e.target.value, 'ParameterDescription', record.Code)
              }
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'Description'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: 'Edge Code',
      dataIndex: 'EdgeCode',
      key: 'EdgeCode',
      ...getColumnSearchProps('EdgeCode'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Input
              value={record.EdgeCode}
              onChange={(e) => handleFieldChange(e.target.value, 'EdgeCode', record.Code)}
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'EdgeCode'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: 'Priority',
      dataIndex: 'Priority',
      key: 'Priority',
      ...getColumnSearchProps('Priority'),
      render: (text, record) => {
        if (record.Editable === 'true') {

          return (
            <Select
              style={{ width: 150 }}
              value={record.Priority}
              onChange={(e) => handleFieldChange(e, 'Priority', record.Code)}
              placeholder={'Priority'}
            >
              {priorityList &&
                Array.isArray(priorityList) &&
                priorityList.map((priority, index) => {
                  return (
                    <Select.Option key={index} value={priority.Value}>
                      {priority.Key}
                    </Select.Option>
                  );
                })}
            </Select>
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: 'Vendor Code',
      dataIndex: 'VendorCode',
      key: 'VendorCode',
      ...getColumnSearchProps('VendorCode'),
      render: (text, record) => {
        if (record.Editable === 'true') {
          return (
            <Input
              value={record.VendorCode}
              onChange={(e) => handleFieldChange(e.target.value, 'VendorCode', record.Code)}
              onKeyDown={(e) => handleKeyPress(e, record.Code)}
              placeholder={'Vendor Code'}
            />
          );
        } else {
          return <div>{text}</div>;
        }
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => {
        if (record.Editable === 'false') {
          return (
            <span>
              <Button onClick={() => editRow(record.Code, record)}>{translation(translationCache, 'Edit')}</Button>
            </span>
          );
        } else {
          if (record.Editable === 'true') {
            return (
              <span>
                <Button onClick={() => saveRow(record)}>{translation(translationCache, 'Save')} </Button>
                <Divider type="vertical" />
                <Button onClick={(e) => cancel(e, record)}>{translation(translationCache, 'Cancel')}</Button>
              </span>
            );
          }
        }
      }
    }
  ];
  const siteId = localStorage.get('currentSite');
  const token = localStorage.get('accessToken');
  var Authorization = 'Bearer ' + token;
  return (
    <div style={{ marginLeft: '17px', minHeight: window.innerHeight - 114 }}>
      <Tabs tabPosition="top" type="card" style={{ marginBottom: '30px' }} className="Modules">
        <TabPane tab={formSentence(props.formTypeName, props.selectedRow, formType)} key="1">
          <Fragment>
            <Form
              name="Item"
              ref={hRef}
              theme={themeSettings}
              initialValues={formObject}
              layout="horizontal"
              labelCol={{ flex: '130px', marginTop: '20px' }}
              labelAlign="right"
              labelWrap
            >
              <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '24px' }}>
                <Form.Item name={'Id'}></Form.Item>
                <Form.Item
                  name="AssetTypeCode"
                  style={{ width: '50%' }}
                  label={translation(translationCache, constant.AssetType)}
                  rules={[
                    {
                      required: true,
                      message: 'Please Select AssetType!'
                    }
                  ]}
                >
                  <Select placeholder={'Please Select Asset Type'} onChange={onChange}>
                    {AssetTypeList &&
                      Array.isArray(AssetTypeList) &&
                      AssetTypeList.map((device, index) => {
                        return (
                          <Option key={index} value={device.Code}>
                            {device.Name}
                          </Option>
                        );
                      })}
                  </Select>
                </Form.Item>
                <Form.Item
                  name="DisplayCode"
                  style={{ width: '50%' }}
                  label={translation(translationCache, constant.DisplayCode)}
                  rules={[
                    {
                      required: true,
                      message: 'Please input DisplayCode!'
                    }
                  ]}
                >
                  <InputComponent
                    placeholder="Input DisplayCode!"
                    value={
                      formObject && formObject.DisplayCode
                        ? translation(translationCache, formObject.DisplayCode)
                        : ''
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="UniqueCode"
                  style={{ width: '50%' }}
                  label={translation(translationCache, constant.Code)}
                  rules={[
                    {
                      required: true,
                      message: 'Please input Code!'
                    }
                  ]}
                >
                  <InputComponent
                    disabled={formObject.Id}
                    placeholder="Input Code!"
                    value={
                      formObject && formObject.UniqueCode
                        ? translation(translationCache, formObject.UniqueCode)
                        : ''
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="Name"
                  style={{ width: '50%' }}
                  label={translation(translationCache, constant.Name)}
                  rules={[
                    {
                      required: true,
                      message: 'Please input Name!'
                    }
                  ]}
                >
                  <InputComponent
                    placeholder="Input Name!"
                    value={
                      formObject && formObject.Name
                        ? translation(translationCache, formObject.Name)
                        : ''
                    }
                  />
                </Form.Item>
                <Form.Item
                  name="Description"
                  style={{ width: '50%' }}
                  label={translation(translationCache, constant.Description)}
                  rules={[
                    {
                      required: true,
                      message: 'Please input Description!'
                    }
                  ]}
                >
                  <Input.TextArea
                    placeholder="Input Description!"
                    value={
                      formObject && formObject.Description
                        ? translation(translationCache, formObject.Description)
                        : ''
                    }
                  />
                </Form.Item>
                {attributeList &&
                  Array.isArray(attributeList) &&
                  attributeList.map((attr, key) => {
                    let requiredField = attr && attr.mandatory === 'Optional' ? false : true;
                    return (
                      <Form.Item
                        key={key}
                        name={attr.Code}
                        label={translation(translationCache, attr.Name)}
                        style={{ width: '50%' }}
                        rules={[
                          { required: requiredField, message: `Please enter  ${attr.Name}!` }
                        ]}
                      >
                        {renderWidget(attr, formObject)}
                      </Form.Item>
                    );
                  })}
              </div>
              <Form.Item {...{ wrapperCol: { offset: 5, span: 16 } }}>
                <Space>
                  {JSON.stringify(props.ShowForm).match(`Asset`) !== null ? (
                    <Button type="primary" onClick={onAssetCRUD}>
                      {`Create`}
                    </Button>
                  ) : (
                    <Button type="primary" onClick={onAssetCRUD}>
                      {`Update`}
                    </Button>
                  )}
                  <Button onClick={onReset}>
                    Reset
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </Fragment>
        </TabPane>
        <TabPane tab={translation(translationCache, 'Parameters')} key="2">
          {(parameterFileName && parameterFileName !== undefined) ||
            (parameterFileName && parameterFileName !== '') ? (
            <div style={{ display: 'flex', justifyContent: 'right', marginTop: '24px' }}>
              <a href={`${IPAddress.LOCAL}${parameterFileName}`}>
                <DownloadOutlined style={{ marginRight: '6px' }} />
                <span style={{ marginRight: '30px' }}>Download </span>
              </a>
              <Upload
                multiple={false}
                style={{ marginRight: '10px' }}
                onChange={(info) => {
                  if (info.file.status === 'done') {
                    message.success(
                      info && info.file && info.file.response && info.file.response.message
                    );

                    getParameterList(props.selectedRow && props.selectedRow.Code, AssetTypeCode);
                    getParameterFileDownloadName(
                      props.selectedRow && props.selectedRow.Code,
                      AssetTypeCode
                    );
                  } else if (info.file.status === 'error') {
                    message.error(
                      info && info.file && info.file.response && info.file.response.message
                    );
                  }
                }}
                action={`${UPLOAD.CLIENT_Upload_AssetParameter}?SiteId=${siteId}&AssetAlias=${props.selectedRow.Code}`}
                headers={{
                  Authorization: Authorization
                }}
                showUploadList={false}
              >
                <UploadOutlined style={{ marginRight: '1px' }} />
                <span style={{ marginRight: '10px' }}> Upload </span>
              </Upload>
            </div>
          ) : null}
          <StyledTable size="small"
            rowKey="Code"
            style={{ marginTop: '10px' }}
            loading={loading}
            columns={columns}
            dataSource={parametersList && Array.isArray(parametersList) ? parametersList : null}
          />
        </TabPane>
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Asset);
